// Copyright 2025, University of Maryland, All Rights Reserved
import { useMutation } from '@tanstack/react-query'
import { useToast } from '@/hooks/use-toast'
import { adminApi } from '@/api/admin-api'

interface SyncParams {
  session?: string;
  maxBills?: number;
  force_changes?: boolean;
}

export function useSyncMutations() {
  const { toast } = useToast()

  const syncMarylandBills = useMutation({
    mutationFn: (params?: SyncParams) => {
      if (!params) {
        return adminApi.syncMarylandBills()
      }
      return adminApi.syncMarylandBills(params.session, params.maxBills, params.force_changes)
    },
    onSuccess: (data, params) => {
      const sessionText = params?.session ? ` for ${params.session}` : ''
      const maxBillsText = params?.maxBills ? ` (max ${params.maxBills} bills)` : ''
      const forceText = params?.force_changes ? ' (forcing changes)' : ''
      toast({
        title: "Sync Job Started",
        description: `Maryland bills sync job started${sessionText}${maxBillsText}${forceText} (Job ID: ${data.job_id})`
      })
    },
    onError: (error, params) => {
      const sessionText = params?.session ? ` for ${params.session}` : ''
      toast({
        title: "Sync Failed",
        description: `Failed to start Maryland bills sync${sessionText}: ${error instanceof Error ? error.message : 'Unknown error'}`,
        variant: "destructive"
      })
    }
  })

  return {
    syncMarylandBills
  }
}
